import React, { useState, useEffect } from "react";
import ReactApexChart from 'react-apexcharts';
import loadingGif from '../../assets/img/loading.gif';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
import Dropdown from 'react-bootstrap/Dropdown';
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from 'jodit-react';
import { joditToolbarReadOnly } from './../../Helpers/JoditToolbar.js';
import { decodeToken, isExpired } from "react-jwt";

const Home = () => {
    const [isTokenExpired, setIsTokenExpired] = useState(false);

    const [loading, setLoading] = useState(false);

    const [yil, setYil] = useState(-1);
    const [dataYil, setDataYil] = useState([]);
    const [dataSayilar, setDataSayilar] = useState([]);
    const [dataDuyuru, setDataDuyuru] = useState([]);
    const [zamanChart, setZamanChart] = useState({ series: [], options: {} });
    const [urunOlcusuChart, setUrunOlcusuChart] = useState({ series: [], options: {} });
    const [urungrubuChart, setUrunGrubuChart] = useState({ series: [], options: {} });
    //const [pieChart, setPieChart] = useState([]);
    const [pieChart, setPieChart] = useState({ series: [], options: {} });

    useEffect(() => {
        getData();
    }, [yil]);

    /*useEffect(() => {
        const timeoutId = setTimeout(() => {
          getData();
        }, 5000);

        return () => clearTimeout(timeoutId);
    }, );*/

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const handleYil = async (yil) => {
        setYil(yil);
    }

    const handleYenile = async () => {
        await getData();
    }

    const getData = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        try {
            setLoading(true);

            const resYil = await axios.get(settings.ApiUrl + "Lookup/GetYil", { headers: AuthService.getHeaders() });
            const resDuyuru = await axios.get(settings.ApiUrl + 'Dashboard/GetDashboardDuyuru', { headers: AuthService.getHeaders() });
            const resSayilar = await axios.post(settings.ApiUrl + 'Dashboard/GetDashboardSayi', JSON.stringify({ "yil": yil }), { headers: AuthService.getHeaders() });
            const resZamanGrafigi = await axios.post(settings.ApiUrl + 'Dashboard/GetDashboardGrafik', JSON.stringify({ "tip": "ZamanGrafigi", "yil": yil }), { headers: AuthService.getHeaders() });
            const resUrunGrubuGrafigi = await axios.post(settings.ApiUrl + 'Dashboard/GetDashboardGrafik', JSON.stringify({ "tip": "UrunGrubuGrafigi", "yil": yil }), { headers: AuthService.getHeaders() });
            const resUrunOlcusuGrafigi = await axios.post(settings.ApiUrl + 'Dashboard/GetDashboardGrafik', JSON.stringify({ "tip": "UrunOlcusuGrafigi", "yil": yil }), { headers: AuthService.getHeaders() });

            setDataYil(resYil.data.value);
            setDataDuyuru(resDuyuru.data.value);
            setDataSayilar(resSayilar.data.value);

            const zamanGrafigiX1 = [];
            const zamanGrafigiX2 = [];
            const zamanGrafigiY = [];

            const urunGrubuGrafigiX = [];
            const urunGrubuGrafigiY = [];

            const urunOlcusuGrafigiX = [];
            const urunOlcusuGrafigiY = [];

            resZamanGrafigi.data.value.forEach(item => {
                zamanGrafigiX1.push(item.x1);
                zamanGrafigiX2.push(item.x2);
                zamanGrafigiY.push(item.y);
            });

            resUrunGrubuGrafigi.data.value.forEach(item => {
                urunGrubuGrafigiX.push(item.x1);
                urunGrubuGrafigiY.push(item.y);
            });

            resUrunOlcusuGrafigi.data.value.forEach(item => {
                urunOlcusuGrafigiX.push(item.x1);
                urunOlcusuGrafigiY.push(item.y);
            });

            setZamanChart({
                series: [{
                    name: "Toplam Ürün Sayısı",
                    data: zamanGrafigiX1
                },
                {
                    name: "Ürün Ölçüsüsü Sayısı",
                    data: zamanGrafigiX2
                }],
                options: {
                    chart: {
                        height: 350,
                        type: 'area',
                        zoom: {
                            enabled: false
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    title: {
                        text: '',
                        align: 'left'
                    },
                    /*grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'],
                            opacity: 0.5
                        },
                    },*/
                    xaxis: {
                        categories: zamanGrafigiY,
                        tooltip: {
                            enabled: false,
                          }
                    }
                }
            });

            setUrunOlcusuChart({
                series: [{
                    name: 'Toplam Ürün Sayısı',
                    data: urunOlcusuGrafigiX
                  }],
                  options: {
                    chart: {
                      height: 350,
                      type: 'bar',
                    },
                    plotOptions: {
                      bar: {
                        borderRadius: 10,
                        dataLabels: {
                          position: 'top', // top, center, bottom
                        },
                      }
                    },
                    dataLabels: {
                      enabled: true,
                      formatter: function (val) {
                        return val;
                      },
                      offsetY: -20,
                      style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                      }
                    },
                    
                    xaxis: {
                      categories: urunOlcusuGrafigiY,
                      position: 'bottom',
                      axisBorder: {
                        show: false
                      },
                      axisTicks: {
                        show: false
                      },
                      crosshairs: {
                        fill: {
                          type: 'gradient',
                          gradient: {
                            colorFrom: '#D8E3F0',
                            colorTo: '#BED1E6',
                            stops: [0, 100],
                            opacityFrom: 0.4,
                            opacityTo: 0.5,
                          }
                        }
                      },
                      tooltip: {
                        enabled: false,
                      }
                    },
                    yaxis: {
                      axisBorder: {
                        show: false
                      },
                      axisTicks: {
                        show: false,
                      },
                      labels: {
                        show: false,
                        formatter: function (val) {
                          return val + " adet";
                        }
                      }
                    },
                    title: {
                      text: '',
                      floating: true,
                      offsetY: 330,
                      align: 'center',
                      style: {
                        color: '#444'
                      }
                    }
                  },
            });

            setUrunGrubuChart({
                series: [{
                    name: 'Toplam Ürün Sayısı',
                    data: urunGrubuGrafigiX
                  }],
                  options: {
                    chart: {
                      height: 350,
                      type: 'bar',
                    },
                    plotOptions: {
                      bar: {
                        borderRadius: 10,
                        dataLabels: {
                          position: 'top', // top, center, bottom
                        },
                      }
                    },
                    dataLabels: {
                      enabled: true,
                      formatter: function (val) {
                        return val;
                      },
                      offsetY: -20,
                      style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                      }
                    },
                    
                    xaxis: {
                      categories: urunGrubuGrafigiY,
                      position: 'bottom',
                      axisBorder: {
                        show: false
                      },
                      axisTicks: {
                        show: false
                      },
                      crosshairs: {
                        fill: {
                          type: 'gradient',
                          gradient: {
                            colorFrom: '#D8E3F0',
                            colorTo: '#BED1E6',
                            stops: [0, 100],
                            opacityFrom: 0.4,
                            opacityTo: 0.5,
                          }
                        }
                      },
                      tooltip: {
                        enabled: false,
                      }
                    },
                    yaxis: {
                      axisBorder: {
                        show: false
                      },
                      axisTicks: {
                        show: false,
                      },
                      labels: {
                        show: false,
                        formatter: function (val) {
                          return val + " adet";
                        }
                      }
                    },
                    title: {
                      text: '',
                      floating: true,
                      offsetY: 330,
                      align: 'center',
                      style: {
                        color: '#444'
                      }
                    }
                  },
            });

            /*const pieChartItems = [];

            resSayilar.data.value.forEach((item) => {
                const temp =    {
                                    series: [(item.x1 - item.x2), item.x2],
                                    options: {
                                        chart: {
                                            width: 380,
                                            type: 'donut',
                                        },
                                        labels: ["Bekleyen", "Kapatılan"],
                                        responsive: [{
                                            breakpoint: 480,
                                            options: {
                                                chart: {
                                                    width: 200
                                                },
                                                legend: {
                                                    position: 'bottom'
                                                }
                                            }
                                        }],
                                    },
                                };

                pieChartItems.push(temp);
            });

            setPieChart(pieChartItems);*/

            setPieChart({
                series: urunGrubuGrafigiX,
                options: {
                    chart: {
                        width: 380,
                        type: 'donut',
                    },
                    labels: urunGrubuGrafigiY,
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
            });
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            {
                loading ?
                    <div className="progressBackground">
                        <div className="progressPopup">
                            <img alt="Bekleyiniz..." src={loadingGif} />
                        </div>
                    </div>
                    :
                    ''
            }
            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    <section className="section dashboard">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="row">
                                    {
                                        dataSayilar && dataSayilar.length > 0 ?
                                            dataSayilar.map((item, index) => {
                                                return (
                                                    <div key={index} className={dataSayilar.length === 4 ? "col-md-3" : "col-md-6"}>
                                                        <div className="card info-card sales-card">
                                                            <div className="filter" style={{display:"flex"}}>
                                                                <button className="btn btn-sm btn-link" onClick={() => handleYenile()} style={{top:"-8px", position:"relative"}}><i className="bi bi-repeat"></i></button>
                                                                <Dropdown style={{top:"-8px", left:"-8px"}}>
                                                                    <Dropdown.Toggle variant="sm" id="dropdown-basic" style={{ border: "none" }}>
                                                                        <i className="bi bi-three-dots"></i>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item key={index} onClick={() => handleYil(-1)}>Tüm Yıllar</Dropdown.Item>
                                                                        {
                                                                            dataYil && dataYil.length > 0 ?
                                                                                dataYil.map((item, index) => {
                                                                                    return (
                                                                                        <Dropdown.Item key={index} onClick={() => handleYil(item.id)}>{item.ad}</Dropdown.Item>
                                                                                    )
                                                                                })
                                                                                :
                                                                                null
                                                                        }
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                            <div className="card-body">
                                                                <h5 className="card-title">{item.tedasDurumu} <span> | {yil === -1 ? "Tüm Yıllar" : yil}</span></h5>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                                        <i className={item.icon}></i>
                                                                    </div>
                                                                    <div className="ps-3">
                                                                        <h6>{item.sayi}</h6>
                                                                        <span className="text-primary small pt-1 fw-bold">{item.toplam}</span> <span className="text-muted small pt-2 ps-1">toplam</span>
                                                                    </div>
                                                                    <div className="ps-4 text-center">
                                                                        <div className="donutContainer">
                                                                            <label>{"% " + Math.round(item.sayi / item.toplam * 10000) / 100}</label>
                                                                            <svg width="80" height="80" xmlns="http://www.w3.org/2000/svg" style={{transform:"rotate(-90deg)"}}>
                                                                                <g>
                                                                                    <circle id="circle" style={{strokeDashoffset: (440 - Math.round(item.sayi / item.toplam * 100 * 2.2)) }} className="donut" r="34.85699" cy="41" cx="41" strokeWidth="8" stroke="#69aff4" fill="none"/>
                                                                                </g>
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            null
                                    }
                                    {
                                        zamanChart && zamanChart.series.length > 0 ?
                                            <div className="col-md-4">
                                                <div className="card">
                                                    <div className="filter" style={{display:"flex"}}>
                                                        <button className="btn btn-sm btn-link" onClick={() => handleYenile()} style={{top:"-8px", position:"relative"}}><i className="bi bi-repeat"></i></button>
                                                        <Dropdown style={{top:"-8px", left:"-8px"}}>
                                                            <Dropdown.Toggle variant="sm" id="dropdown-basic" style={{ border: "none" }}>
                                                                <i className="bi bi-three-dots"></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item key={-1} onClick={() => handleYil(-1)}>Tüm Yıllar</Dropdown.Item>
                                                                {
                                                                    dataYil && dataYil.length > 0 ?
                                                                        dataYil.map((item, index) => {
                                                                            return (
                                                                                <Dropdown.Item key={index} onClick={() => handleYil(item.id)}>{item.ad}</Dropdown.Item>
                                                                            )
                                                                        })
                                                                        :
                                                                        null
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                    <div className="card-body">
                                                        <h5 className="card-title">Günlük İşlem Grafiği<span> | {yil === -1 ? "Tüm Yıllar" : yil}</span></h5>
                                                        <ReactApexChart options={zamanChart.options} series={zamanChart.series} type="line" height={350} />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            ""
                                    }
                                    {/* {
                                        pieChart && pieChart.series.length > 0 ?
                                            <div className="col-md-4">
                                                <div className="card">
                                                    <div className="filter" style={{display:"flex"}}>
                                                        <button className="btn btn-sm btn-link" onClick={() => handleYenile()} style={{top:"-8px", position:"relative"}}><i className="bi bi-repeat"></i></button>
                                                        <Dropdown style={{top:"-8px", left:"-8px"}}>
                                                            <Dropdown.Toggle variant="sm" id="dropdown-basic" style={{ border: "none" }}>
                                                                <i className="bi bi-three-dots"></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item key={-1} onClick={() => handleYil(-1)}>Tüm Yıllar</Dropdown.Item>
                                                                {
                                                                    dataYil && dataYil.length > 0 ?
                                                                        dataYil.map((item, index) => {
                                                                            return (
                                                                                <Dropdown.Item key={index} onClick={() => handleYil(item.id)}>{item.ad}</Dropdown.Item>
                                                                            )
                                                                        })
                                                                        :
                                                                        null
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                    <div className="card-body">
                                                        <h5 className="card-title">Başvuru Türleri<span> | {yil === -1 ? "Tüm Yıllar" : yil}</span></h5>
                                                        <ReactApexChart options={pieChart.options} series={pieChart.series} type="donut" height={362} />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            ""
                                    } */}
                                    {
                                        urunOlcusuChart && urunOlcusuChart.series.length > 0 ?
                                            <div className="col-md-4">
                                                <div className="card">
                                                    <div className="filter" style={{display:"flex"}}>
                                                        <button className="btn btn-sm btn-link" onClick={() => handleYenile()} style={{top:"-8px", position:"relative"}}><i className="bi bi-repeat"></i></button>
                                                        <Dropdown style={{top:"-8px", left:"-8px"}}>
                                                            <Dropdown.Toggle variant="sm" id="dropdown-basic" style={{ border: "none" }}>
                                                                <i className="bi bi-three-dots"></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item key={-1} onClick={() => handleYil(-1)}>Tüm Yıllar</Dropdown.Item>
                                                                {
                                                                    dataYil && dataYil.length > 0 ?
                                                                        dataYil.map((item, index) => {
                                                                            return (
                                                                                <Dropdown.Item key={index} onClick={() => handleYil(item.id)}>{item.ad}</Dropdown.Item>
                                                                            )
                                                                        })
                                                                        :
                                                                        null
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                    <div className="card-body">
                                                        <h5 className="card-title">Ürün Ölçüleri<span> | {yil === -1 ? "Tüm Yıllar" : yil}</span></h5>
                                                        <ReactApexChart options={urunOlcusuChart.options} series={urunOlcusuChart.series} type="bar" height={350} />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            ""
                                    }
                                    {
                                        urungrubuChart && urungrubuChart.series.length > 0 ?
                                            <div className="col-md-4">
                                                <div className="card">
                                                    <div className="filter" style={{display:"flex"}}>
                                                        <button className="btn btn-sm btn-link" onClick={() => handleYenile()} style={{top:"-8px", position:"relative"}}><i className="bi bi-repeat"></i></button>
                                                        <Dropdown style={{top:"-8px", left:"-8px"}}>
                                                            <Dropdown.Toggle variant="sm" id="dropdown-basic" style={{ border: "none" }}>
                                                                <i className="bi bi-three-dots"></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item key={-1} onClick={() => handleYil(-1)}>Tüm Yıllar</Dropdown.Item>
                                                                {
                                                                    dataYil && dataYil.length > 0 ?
                                                                        dataYil.map((item, index) => {
                                                                            return (
                                                                                <Dropdown.Item key={index} onClick={() => handleYil(item.id)}>{item.ad}</Dropdown.Item>
                                                                            )
                                                                        })
                                                                        :
                                                                        null
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                    <div className="card-body">
                                                        <h5 className="card-title">Ürün Grupları<span> | {yil === -1 ? "Tüm Yıllar" : yil}</span></h5>
                                                        <ReactApexChart options={urungrubuChart.options} series={urungrubuChart.series} type="bar" height={350} />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            ""
                                    }
                                    {
                                        dataDuyuru && dataDuyuru.length > 0 ?
                                            dataDuyuru.map((item, index) => {
                                                return (
                                                    <div key={index} className="col-md-12">
                                                        <div className={index === (dataDuyuru.length - 1) ? "card mb-2" : "card"}>
                                                            <div className="card-body">
                                                                <h5 className="card-title">{item.konu}</h5>
                                                                <JoditEditor config={joditToolbarReadOnly} value={item.icerik}></JoditEditor>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
            }
        </div>
    )
}

export default Home;